{
  "links": [
    {
      "identifier": "overview",
      "href": "/overview",
      "name": "Загальний огляд"
    },
    { "identifier": "metrics", "href": "/metrics/hmt", "name": "Показники" },
    { "identifier": "groups", "href": "/groups", "name": "Групи" },
    {
      "identifier": "research",
      "href": "/research",
      "name": "Дослідження"
    }
  ],
  "popover-actions": [
    {
      "text": "Вихід",
      "action": "logout"
    }
  ]
}
